import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent {
  @Input() isAuthPage: boolean;
  currentDate: Date = new Date();
  currentYear = new Date().getFullYear();
}
